<template>
  <!-- <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container> -->

  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <router-view v-if="isRouterAlive"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
  var rules = [];
  // 导入组件
  import navcon from '../components/navcon.vue'
  import leftnav from '../components/leftnav.vue'
  import { menu } from '../api/userMG';
  export default {
    name: 'index',
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        showclass: 'asideshow',
        showtype: false,
        isRouterAlive: true
      }
    },
    // 注册组件
    components: {
      navcon,
      leftnav
    },
    computed: {
      ruleslist() {
        return this.$store.state.ruleslist;
      },
    },
    watch: {
      ruleslist:function(newVal,oldVal){
        if(oldVal && oldVal.length && JSON.stringify(newVal) != JSON.stringify(oldVal)){
          this.reload();
        }
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      },
      getmenu() {
        rules=[];
        menu().then(res => {
          if (res.statusCode == 200) {
            var allmenu = res.data.modulelist
            this.$store.commit('SET_NAME', res.data.username)
            this.$store.commit('SET_MENU', allmenu)
            allmenu.forEach(item => {
              this.changemenuTree(item.modulelist);
            });
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      },
      // 递归
      changemenuTree(data) {
        data.forEach(cell => {
          if (!cell.route && rules.indexOf(cell.module_code) == -1) {
            rules.push(cell.module_code)
          }
          // 递归，如果有子元素modulelist则调用自身
          if (cell.modulelist && cell.modulelist.length) {
            this.changemenuTree(cell.modulelist)
          }
        });
        if(rules){
          this.$store.commit('SET_RULE', rules)
          localStorage.setItem('rules',JSON.stringify(rules))
        }
      }
    },
    created() {
      // 监听
      this.$root.Bus.$on('toggle', value => {
        if (value) {
          this.showclass = 'asideshow'
        } else {
          setTimeout(() => {
            this.showclass = 'aside'
          }, 300)
        }
      })
    },
    beforeUpdate() { },
    // 挂载前状态(里面是操作)
    beforeMount() { 
      this.getmenu()
    }
  }
</script>
<style>
  .index-con {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }

  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }

  .asideshow {
    width: 240px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }

  .index-header,
  .index-main {
    padding: 0px;
    border-left: 2px solid #333;
  }
</style>


// WEBPACK FOOTER //
// src/views/index.vue